import { configureStore } from '@reduxjs/toolkit';
import { persistReducer, persistStore } from 'redux-persist';
import { combineReducers } from 'redux';
import storage from 'redux-persist/lib/storage/session'; // Use sessionStorage for tab isolation
import AuthSlice from '../Shared/Slice/AuthSlice';
import ProfileSlice from '../Shared/Slice/ProfileSlice';
import LoaderSlice from '../Shared/Slice/LoaderSlice';
import OrdersSlice from '../Shared/Slice/OrdersSlice';

const rootReducer = combineReducers({
  auth: AuthSlice,
  user: ProfileSlice,
  loader: LoaderSlice,
  orders: OrdersSlice,
});

const persistConfig = {
  key: 'swimscore_tab_root',
  storage,
  // Only persist auth state for tab-specific sessions
  whitelist: ['auth'],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }),
});

export const persistor = persistStore(store);
